
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jointheresistance",
      function () {
        return require("private-next-pages/jointheresistance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jointheresistance"])
      });
    }
  